export const customersCompaniesData = [
  {
    key: "1",
    COMPANY_IMG: "company-1.jpg",
    COMPANY: "Elite Solutions",
    CONTACT_DETAILS: "Andrew Simons",
    CONTACT_IMG: "customer-11.jpg",
    PHONE: "+1 56598 98956",
    EMAIL: "andrewsimons@example.com",
    FLAGS_IMG: "gb.svg",
    LANGUAGE: "English",
    RENTS: "Recent Rents",
  },
  {
    key: "2",
    COMPANY_IMG: "company-2.jpg",
    COMPANY: "Violet Photography",
    CONTACT_DETAILS: "David Steiger",
    CONTACT_IMG: "customer-12.jpg",
    PHONE: "+1 24558 56599",
    EMAIL: "davidsteiger@example.com",
    FLAGS_IMG: "it-flag.svg",
    LANGUAGE: "Italian",
    RENTS: "Recent Rents",
  },
  {
    key: "3",
    COMPANY_IMG: "company-3.jpg",
    COMPANY: "Dynasty",
    CONTACT_DETAILS: "Darin Mabry",
    CONTACT_IMG: "customer-13.jpg",
    PHONE: "+1 24558 56599",
    EMAIL: "darinmabry@example.com",
    FLAGS_IMG: "fr-flag.svg",
    LANGUAGE: "French",
    RENTS: "",
  },
  {
    key: "4",
    COMPANY_IMG: "company-4.jpg",
    COMPANY: "Flame Quill",
    CONTACT_DETAILS: "Mark Neiman",
    CONTACT_IMG: "customer-14.jpg",
    PHONE: "+1 56598 98956",
    EMAIL: "markneiman@example.com",
    FLAGS_IMG: "gb.svg",
    LANGUAGE: "English",
    RENTS: "Recent Rents",
  },
  {
    key: "5",
    COMPANY_IMG: "company-5.jpg",
    COMPANY: "Quill Pen Finance",
    CONTACT_DETAILS: "Jacob Johnson",
    CONTACT_IMG: "customer-15.jpg",
    PHONE: "+1 56598 98956",
    EMAIL: "jacobjohnson@example.com",
    FLAGS_IMG: "gb.svg",
    LANGUAGE: "German",
    RENTS: "",
  },
  {
    key: "6",
    COMPANY_IMG: "company-6.jpg",
    COMPANY: "Heavenly Flow",
    CONTACT_DETAILS: "Walter Hartmann",
    CONTACT_IMG: "customer-16.jpg",
    PHONE: "+1 24558 56599",
    EMAIL: "walterhartmann@example.com",
    FLAGS_IMG: "it-flag.svg",
    LANGUAGE: "Italian",
    RENTS: "Recent Rents",
  },
  {
    key: "7",
    COMPANY_IMG: "company-7.jpg",
    COMPANY: "Butterfly Creative",
    CONTACT_DETAILS: "Andrea Jermaine",
    CONTACT_IMG: "customer-17.jpg",
    PHONE: "+1 12488 14457",
    EMAIL: "andreajermaine@example.com",
    FLAGS_IMG: "gb.svg",
    LANGUAGE: "English",
    RENTS: "",
  },
  {
    key: "8",
    COMPANY_IMG: "company-8.jpg",
    COMPANY: "Sand Studios",
    CONTACT_DETAILS: "Dennis Eckhardt",
    CONTACT_IMG: "customer-18.jpg",
    PHONE: "+1 32569 15458",
    EMAIL: "denniseckhardt@example.com",
    FLAGS_IMG: "it-flag.svg",
    LANGUAGE: "Italian",
    RENTS: "Recent Rents",
  },
  {
    key: "9",
    COMPANY_IMG: "company-9.jpg",
    COMPANY: "Colibri Solutions",
    CONTACT_DETAILS: "Lan Adams",
    CONTACT_IMG: "customer-19.jpg",
    PHONE: "+1 14782 14578",
    EMAIL: "lanadams@example.com",
    FLAGS_IMG: "fr-flag.svg",
    LANGUAGE: "French",
    RENTS: "",
  },
  {
    key: "10",
    COMPANY_IMG: "company-10.jpg",
    COMPANY: "Bishu Infotech",
    CONTACT_DETAILS: "Julie Black",
    CONTACT_IMG: "customer-20.jpg",
    PHONE: "+1 12124 14255",
    EMAIL: "julieblack@example.com",
    FLAGS_IMG: "gb.svg",
    LANGUAGE: "English",
    RENTS: "Recent Rents",
  },
];
